import React from "react";
import LogoFullName from "../public/assets/img/NTLogowithFullName.png";
import { Link, Outlet } from "react-router-dom";
import Footer from "./Footer";

function Navbar() {
  return (
    <div>
      <nav className="fixed inset-x-0 top-0 z-50 bg-white shadow-sm">
        <div className="mx-auto flex max-w-7xl flex-col items-center gap-2 px-4 py-3 sm:h-16 sm:flex-row sm:justify-between sm:gap-6">
          <div className="shrink-0">
            <img
              width="287"
              height="55"
              src={LogoFullName}
              alt="บริษัท โทรคมนาคมแห่งชาติ จำกัด (มหาชน)"
              className="h-auto w-52 sm:w-60 lg:w-[287px]"
            />
          </div>
          <ul className="flex w-full items-center justify-start gap-5 overflow-x-auto whitespace-nowrap pb-1 text-sm text-black sm:w-auto sm:justify-end sm:gap-6 sm:pb-0 lg:text-base">
            <li>
              <Link to={"/"} className="block py-1 hover:text-amber-600">
                หน้าหลัก
              </Link>
            </li>
            <li>
              <Link to={"/document"} className="block py-1 hover:text-amber-600">
                เอกสารเผยแพร่
              </Link>
            </li>
            <li>
              <Link to={"/policy"} className="block py-1 hover:text-amber-600">
                นโยบายคุ้มครองข้อมูลส่วนบุคคล
              </Link>
            </li>
          </ul>
        </div>
      </nav>
      <div className="pt-[108px] sm:pt-16">
        <Outlet />
      </div>
      <footer>
        <Footer />
      </footer>
    </div>
  );
}

export default Navbar;
